import React from 'react';
import Alert from 'Components/DesignSystem/Alert/Alert';

type TABToast = {
    msg1?: string;
    msg2: string;
}

/**
 * The results-page notification banner (`okf/design-system/e2e.md` § 153).
 *
 * **Not a toast, despite the name** — it is an inline banner rendered in the page body,
 * and it always has been. The name is kept because three call sites and the module's
 * own tests use it; renaming is a separate change from restyling.
 *
 * It was `tw-bg-[#fffae6]` inside `tw-border-[#ffc400]` with a decorative `AlertIcon`
 * and a hardcoded `tw-h-11` — a fixed height, so a two-line notification overflowed its
 * own box. As a DS `Alert tone="warning"` it wraps, and it is **announced**: the legacy
 * version was a coloured div, so a screen-reader user was never told the test had been
 * completed and traffic reassigned.
 *
 * `msg1` renders as the Alert's title when present. No current caller passes it —
 * `ResultSection1` uses `msg2` only, and `ABPromoteModal`'s two-argument call site is
 * commented out — but it stays part of the signature.
 */
const ABToast = ({ msg1, msg2 }: TABToast) => {
    return (
        <div className="tw-flex tw-justify-center tw-mt-4">
            <Alert
                tone="warning"
                title={msg1}
                live
                data-testid="ab-result-notification"
                className="tw-w-auto"
            >
                {msg2}
            </Alert>
        </div>
    );
}

export default ABToast;
